import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../constants/config";
import SuperAdminDashboardContent from "./SuperAdminDashboardContent";

function DashboardOverview() {
  const navigate = useNavigate();
  const [schools, setSchools] = useState([]);
  const [userStats, setUserStats] = useState({
    totalUsers: 0,
    totalStudents: 0,
    totalTeachers: 0,
    totalStaff: 0,
    totalVanDrivers: 0,
  });
  const [trends, setTrends] = useState(null);

  useEffect(() => {
    fetchSchoolStats();
    fetchUserStats();
    fetchTrends();
  }, []);

  const fetchSchoolStats = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(API_ENDPOINTS.schoolsStats, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSchools(response.data.data.schools || []);
    } catch {
      try {
        const token = localStorage.getItem("token");
        const response = await axiosInstance.get(API_ENDPOINTS.schools, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSchools(response.data.data.schools || []);
      } catch {
        setSchools([]);
      }
    }
  };

  const fetchUserStats = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(API_ENDPOINTS.usersStats, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUserStats((prev) => ({ ...prev, ...response.data.data }));
    } catch {
      // keep defaults
    }
  };

  const fetchTrends = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(API_ENDPOINTS.logsTrends("days=14"), {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTrends(response.data.trends);
    } catch {
      setTrends(null);
    }
  };

  const handleNavigate = (tab) => {
    if (tab === "logs") {
      navigate("/dashboard/system-logs");
    } else if (tab === "schools") {
      navigate("/dashboard/schools");
    } else if (tab === "app-version") {
      navigate("/dashboard/app-version");
    }
  };

  return (
    <SuperAdminDashboardContent
      schools={schools}
      userStats={userStats}
      trends={trends}
      onNavigate={handleNavigate}
    />
  );
}

export default DashboardOverview;
